import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SectoresProductivosService } from 'src/app/services/sectores-productivos.service';

import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-sectores-estandares',
  templateUrl: './sectores-estandares.component.html',
  styleUrls: ['./sectores-estandares.component.css']
})
export class SectoresEstandaresComponent implements OnInit {


  sectGenerales: any;
  subsectores: any;
  displayedColumns: string[] = ['id', 'descripcion', 'noestandares'];

  dataSource: any;
  listado: any;
  listadoEm: any;
  longitud: any;

  @Output()
  estandar = new EventEmitter<string>();

  @Output()
  sectorEsById = new EventEmitter<any>();

  @Output()
  esandarMarcaDes = new EventEmitter<any>();

  @Output()
  estandarBackTo = new EventEmitter<number>();

  @Input() idSector: number;
  @Input() title: string;
  @Input() padre: number;
  @Input() tablaEstandar: boolean;

  @Input() estandarDes: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private service: SectoresProductivosService) {
    this.idSector = 0;
    this.padre = 0;
    // this.estandar = "";
    this.estandarDes = "";
  }

  ngOnInit(): void {
    this.getSectores();
  }

  async getSectores() {
    if (this.estandarDes.trim() === "") {
      this.estandarDes = 'NA';
    }
    try {
      let get: any;
      if (this.idSector === 0) {
        get = await this.service.getSectoresProductivos();
      } else {
        get = await this.service.getSectoresProductivosById(this.idSector, this.estandarDes);
        this.longitud = get.length;

      }
      this.listado = get;
      //this.verificaLongitud();
      var total
      this.dataSource = new MatTableDataSource<any>(get)
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.log(error);
    }
  } ''

  async getSectoresByEstandar(event: any) {
    try {
      let get: any;
      if (event.target.value.trim() !== "") {
        get = await this.service.getSectoresProductivosByEstandar(event.target.value.trim());
      } else {
        get = await this.service.getSectoresProductivos();
      }
      this.listado = get;
      this.verificaLongitud();
      this.dataSource = new MatTableDataSource<any>(get)
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.estandar.emit(event.target.value.trim());
    } catch (error) {
      console.log(error);
    }
  }


  async getSectoresById() {
    try {
      const get = await this.service.getSectoresProductivosById(1, 'NA');
      this.subsectores = get;
    } catch (error) {
      console.log(error);
    }
  }

  sectorByID(element) {

    let json = {
      element: element,
      padre: this.padre,
      titlePadre: this.title,

    }
    this.sectorEsById.emit(json);
  }


  sectorByTra() {

    let json = {
      element: 21,
      padre: this.padre,
      titlePadre: this.title,

    }
    this.sectorEsById.emit(json);
  }


  back() {
    this.estandarBackTo.emit(this.idSector);

  }

  home() {
    window.location.reload();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  verificaLongitud() {
    if (this.listado !== undefined) {
      var aux = 0;
      for (var i = 0; i < this.listado.length; i++) {
        aux = i;
        if (i === 0 || i === 3 || i === 6 || i === 9 || i === 12 || i === 15 || i === 18) {
          if (this.listado[aux] !== undefined && this.listado[aux + 1] !== undefined && this.listado[aux + 2] !== undefined) {
            if (this.listado[aux].descripcion.length <= 34 && this.listado[aux + 1].descripcion.length <= 34 && this.listado[aux + 2].descripcion.length <= 34) {
              var el = document.getElementById("" + i);
              if (el !== null)
                el.style.height = '70px';
              var el = document.getElementById("" + (i + 1));
              if (el !== null)
                el.style.height = '70px';
              var el = document.getElementById("" + (i + 2));
              if (el !== null)
                el.style.height = '70px';
            }
          }
        }
      }
    }
  }

  ngAfterViewChecked() {
    this.verificaLongitud();
  }

}
